import * as React from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

function AlertDialog({ ...props }: React.ComponentProps<typeof Dialog>) {
  return (
    <Dialog
      data-slot="alert-dialog"
      {...props}
    />
  );
}

function AlertDialogAction({ ...props }: React.ComponentProps<typeof Button>) {
  return (
    <Button
      data-slot="alert-dialog-action"
      {...props}
    />
  );
}

function AlertDialogCancel({
  className,
  variant = 'outline',
  ...props
}: React.ComponentProps<typeof Button>) {
  return (
    <DialogClose asChild>
      <Button
        className={cn('mt-2 sm:mt-0', className)}
        data-slot="alert-dialog-cancel"
        variant={variant}
        {...props}
      />
    </DialogClose>
  );
}

function AlertDialogContent({
  className,
  ...props
}: React.ComponentProps<typeof DialogContent>) {
  return (
    <DialogContent
      className={cn('sm:max-w-lg', className)}
      data-slot="alert-dialog-content"
      showCloseButton={false}
      {...props}
    />
  );
}

function AlertDialogDescription({
  ...props
}: React.ComponentProps<typeof DialogDescription>) {
  return (
    <DialogDescription
      data-slot="alert-dialog-description"
      {...props}
    />
  );
}

function AlertDialogFooter({
  ...props
}: React.ComponentProps<typeof DialogFooter>) {
  return (
    <DialogFooter
      data-slot="alert-dialog-footer"
      {...props}
    />
  );
}

function AlertDialogHeader({
  ...props
}: React.ComponentProps<typeof DialogHeader>) {
  return (
    <DialogHeader
      data-slot="alert-dialog-header"
      {...props}
    />
  );
}

function AlertDialogTitle({
  ...props
}: React.ComponentProps<typeof DialogTitle>) {
  return (
    <DialogTitle
      data-slot="alert-dialog-title"
      {...props}
    />
  );
}

function AlertDialogTrigger({
  ...props
}: React.ComponentProps<typeof DialogTrigger>) {
  return (
    <DialogTrigger
      data-slot="alert-dialog-trigger"
      {...props}
    />
  );
}

export {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger
};
